import axios from "axios";


const Axios = axios.create({
    // Each environment's Jenkins build copies its own .env (prod/staging/dev)
    // which sets REACT_APP_BASE_URL. The admin URL fallback keeps prod safe
    // even if the var is missing on the build server.
    baseURL: `${process.env.REACT_APP_BASE_URL || "https://admin.nurturebynaps.com/"}api/`
})

Axios.interceptors.request.use(
    (config) => {
        const Token = localStorage.getItem("Nurture_user_token")
        let TokenType: any = localStorage.getItem("Nurture_user_data");
        TokenType = JSON.parse(TokenType)?.token_type ?? "Bearer"
        if (Token) {
            config.
                headers = {
                Authorization: `${TokenType} ${Token}`,
                Accept: "application/json",
            }
        }
        return config;
    }
)

Axios.interceptors.response.use(
    r => r,
    (error) => {
        if (error?.response?.status === 401 && localStorage.getItem("Nurture_user_token")) {
            window.dispatchEvent(new Event("userLogOut"));
        }
        
        // Throw the error so catch blocks in components can handle it
        throw error;
    }
);

export default Axios;